var _style, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8F3F0;}\n\t.st1{fill:#4C00FF;}\n\t.st2{fill:#FF5252;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 400,
    height: 400
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.5,263.4v73.7c0,3.9-3.1,7-7,7H62.8c-3.9,0-7-3.1-7-7V143.6c0-3.9,3.1-7,7-7h73.6v119.9c0,3.9,3.1,7,7,7 h120.1V263.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344.2,159.5c0,61.9-36.2,103.8-80.7,103.9v-78c0-2.2-0.9-4.5-2.5-6L220.5,139c-1.6-1.6-3.7-2.5-6-2.5h-78 V62.9c0-3.9,3.1-7,7-7h109.1C304.5,55.7,344.2,97.4,344.2,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,179.3c1.6,1.6,2.5,3.7,2.5,6v78h-120c-3.9,0-7-3.1-7-7V136.4h78c2.2,0,4.5,0.9,6,2.5L261,179.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.f2af8511f036e2d2f1c7c39304ffa580.svg";
export { ForwardRef as ReactComponent };